import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/invitationRevoke';
import { fetchRequest as fetchMembers } from '../../actions/organizations/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { orgId, invitationId } = action.payload;
  try {
    yield call(
      axios.delete,
      `${config.API_URL}/organization/${orgId}/invitations/${invitationId}`,
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Invitation revoked' });
    yield put(fetchSuccess({ invitationId }));
    yield put(fetchMembers({ orgId }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not revoke invitation';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  // takeEvery: revocations of different invitations may run in parallel.
  yield takeEvery(REQUEST, operation);
}
